import useJwt from "@/libs/auth/jwt/useJwt";

const axios = useJwt.axiosIns;

export const getRealTimeParams = (params) => axios.get("/api/hjj2/params/real-time-params", {params});
export const getHours48Params = (params) => axios.get("/api/hjj2/params/hours-48-params", {params});

export const getMultipleParams = (params) => axios.get("/api/hjj2/params/multiple-params", {params});